import { useMutation } from "@tanstack/react-query";

import { updateQuoteRequestClient } from "#modules/quoteRequests/infra/updateQuoteRequestClient.api";

export const useUpdateQuoteRequestClient = () => {
  return useMutation({ mutationFn: updateQuoteRequestClient });
};
